import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { getReview } from "../../../api/content/reviewsApi";
import { useLoad } from "../../../shared/loading/useLoad";
import MarkdownRenderer from "../../../ui/content/MarkdownRenderer";
import LoadStatus from "../../../ui/feedback/LoadStatus";
import ItemUnit from "../focus/ItemUnit";
import ChecksPanel from "./ChecksPanel";

/**
 * A change set where a step of its Run reviews it (ADR-0031 D4; IM-THREAD: "A review is a step of its Run and opens
 * there, never as a separate page"): what its author wrote it for, such as each drafted question's evidence; each
 * changed item as the review page shows it; then the checks of its head with their findings. It only shows; the
 * step's own answer confirms it or talks with the agent.
 */
export default function ReviewedChangeSet({ changeSetId }: { changeSetId: string }) {
  const { t } = useTranslation();
  const load = useCallback((signal: AbortSignal) => getReview(changeSetId, signal), [changeSetId]);
  const { state, reload } = useLoad(load);
  if (state.status !== "loaded") return <LoadStatus state={state} loadingLabel={t("common.loading")} onRetry={reload} compact />;
  const review = state.value;
  return (
    <div className="mt-1 space-y-3">
      {review.changeSet.description === "" ? null : <MarkdownRenderer content={review.changeSet.description} className="app-markdown text-sm" />}
      <ul className="space-y-2">
        {review.items.map((item) => (
          <li key={item.itemId} className="app-card p-3">
            <ItemUnit item={item} review={review} edits={null} />
          </li>
        ))}
      </ul>
      <ChecksPanel review={review} />
    </div>
  );
}
